$(document).ready(function() {
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if ($(window).scrollTop() > 200) {
            $('.headerWrapper').addClass('active');
            $('.whiteLogo').addClass('defaultLogo');
        } else {
            $('.headerWrapper').removeClass('active');
            $('.whiteLogo').removeClass('defaultLogo');
        }
    });
  
  
  	$('.slickslider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
      ]
    });
});